import { render, staticRenderFns } from "./VkIcon.vue?vue&type=template&id=6318094a&"
import script from "./VkIcon.vue?vue&type=script&lang=js&"
export * from "./VkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports